/**
 * Registre des modules du centre d'administration. Chaque entree pilote
 * a la fois la navigation (AdminLayout) et le sous-routage (AdminRoutes).
 * Pour ajouter un futur module : une entree ici + sa route + ses cles
 * i18n admin.modules.<id> / admin.descriptions.<id> - rien d'autre a
 * changer dans le shell.
 */
export const ADMIN_MODULES = [
  { id: "overview",     path: "overview",     icon: "◈" },
  { id: "users",        path: "users",        icon: "◉" },
  { id: "cases",        path: "cases",        icon: "▣" },
  { id: "transactions", path: "transactions", icon: "◇" },
  { id: "audit",        path: "audit",        icon: "☰" },
  { id: "settings",     path: "settings",     icon: "⚙" },
];
